import Spinner from "./Spinners";

export default function CustomButton({
  children,
  onClick,
  className,
  disabled,
  type = "button",
  loading,
  variant = "default",
  size = "lg",
  ...props
}: {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  loading?: boolean;
  variant?: "default" | "secondary" | "link" | "ghost" | "outline";
  size?: "default" | "sm" | "lg" | "icon";
}) {
  return (
    <button
      className={`h-10 transition duration-75 rounded-[4px] text-sm font-medium leading-[20px] py-2.5 px-4 flex gap-1.5 items-center justify-center
    ${
      variant === "outline"
        ? "border border-brand-primary !text-brand-primary shadow-field hover:!text-content-inverse"
        : ""
    }
    ${variant === "default" ? "bg-brand-primary text-content-inverse" : ""}
    ${
      variant === "link"
        ? `!bg-transparent text-brand-primary ${
            !disabled ? "hover:!text-brand-primary-hover" : "opacity-50"
          } !p-0`
        : ""
    }
    ${
      disabled || loading
        ? "cursor-not-allowed !bg-surface-disabled !text-content-disabled"
        : "hover:bg-brand-primary-hover"
    }
    ${className || ""}
  `}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      {...props}
    >
      {loading ? (
        <Spinner
          className={variant === "outline" || variant === "ghost" ? "text-neutralBlack" : "text-white"}
        />
      ) : (
        children
      )}
    </button>
  );
}
